import { Link, NavLink } from 'react-router-dom';
import { forwardRef } from 'react';
import './header.scss';

const Header = forwardRef(function Header(props, ref) {

  return (
    <>
      <header className="App-header" ref={ref}>
        <div className='container'>
            <div className='App-header-wrap'>
              <a href="/../" className='header-logo'><img src='/wp-content/themes/uspsdelivers/media/logo.svg' className="logo" alt="USPS Delivers™" /></a> 

              <div className='mobile-key-takeaways-btn'>
                <NavLink activeClassName="active" to="/key-takeaways">Key Takeaways</NavLink>
              </div>

              <ul className='main-menu'>
                <li><NavLink className="financial-btn" activeClassName="active" to="/financial">Financial</NavLink></li>
                <li><NavLink className="retail-btn" activeClassName="active" to="/retail">Retail</NavLink></li>
                <li><NavLink className="cpg-btn" activeClassName="active" to="/cpg">CPG</NavLink></li>
                <li><NavLink className="insurance-btn" activeClassName="active" to="/insurance">Insurance</NavLink></li>
                <li><NavLink className="health-btn" activeClassName="active" to="/health">Health</NavLink></li>
              </ul>
              <NavLink className="key-takeaways-btn" activeClassName="active" to="/key-takeaways" className='link-key'>Key Takeaways</NavLink>
            </div>
          </div>
      </header>
    </>
  );

});

export default Header;